<article>
    <section class="top-section pl-6 pr-6 d-flex flex-row flex-wrap align-items-end">
        <div class="col-12 col-sm col-lg-8 p-0 pr-sm-6 pr-0">
            <ng-container
                *ngTemplateOutlet="errorCode === ErrorCode.Error403 ? template403 : template401"
            ></ng-container>
        </div>
        <div class="d-none d-sm-block">
            <img class="error-img" [src]="image" alt="error image" />
        </div>
    </section>
    <section class="bottom-section w-100 pb-2" *ngIf="showContent">
        <app-subject-list
            class="d-block pl-6 pr-6"
            [subjects]="subjects"
            *ngIf="learningObjects.length === 0"
        ></app-subject-list>
        <app-resource-list
            class="d-flex flex-wrap justify-content-between ml-2 mr-2"
            *ngIf="learningObjects.length > 0"
            [learningObjects]="learningObjects"
        ></app-resource-list>
    </section>
</article>
<ng-template #template401>
    <h1 class="mb-6 text-center text-sm-left selenium-page-title">401</h1>
    <div class="description">
        <div>You must be signed in to view this page. Please sign in below.</div>
        <div *ngIf="errorMessage" class="debug-error-message mt-2">ERROR: {{ errorMessage }}</div>
    </div>

    <div class="d-flex flex-nowrap justify-content-center justify-content-sm-start">
        <app-register [buttonLabelText]="'Teacher Sign In'" [nextURL]="nextURL"></app-register>
        <app-register
            [isStudent]="isStudent"
            [buttonLabelText]="'Student Sign In'"
            [nextURL]="nextURL"
        ></app-register>
    </div>
</ng-template>
<ng-template #template403>
    <h1 class="mb-6 text-center text-sm-left selenium-page-title">403</h1>
    <div class="description">
        <div class="mb-6">This page is not available.</div>
        <div>
            Try searching for something similar, or check out our
            <a [routerLink]="[isStudent ? '/student' : '/']" title="Homepage">home page</a>
            for featured resources and collections..
        </div>
        <div *ngIf="errorMessage" class="debug-error-message mt-2">ERROR: {{ errorMessage }}</div>
    </div>
    <app-external-search-input
        class="d-block"
        placeholder="Search Keyword(s)"
    ></app-external-search-input>
</ng-template>
